var _defs, _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552 193",
    width: 121,
    height: 44
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -13.936 32.933 0 91.339 188.828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c6bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00418f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -13.937 33.964 0 22.654 116.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43bbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e9ed9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -13.936 33.964 0 57.523 152.525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c32d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d84f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd8b86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g4",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.695 -21.825 33.564 11.834 55.492 15.549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e9ed9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43bbca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g5",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(29.314 -83.138 34.282 12.088 -30.221 78.304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e9ed9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43bbca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g6",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.442 -18.914 29.919 10.19 90.792 51.128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c32d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d84f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd8b86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g7",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.987 -73.367 31.14 10.606 5.67 113.218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c32d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d84f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd8b86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g8",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(27.482 -67.649 28.465 11.564 39.706 144.248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c6bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00418f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g9",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.862 -19.354 26.764 10.873 124.072 87.773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c6bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00418f"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo_svg__s3{fill:#231815}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__\\u56FE\\u5C42_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M121.6 173.5l-10.5-2.2-40.1 9.1S66.2 193 81.8 193h32.8z",
    fill: "url(#logo_svg__g1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M1.4 108s-4.9 12.5 10.8 12.5h41.3L52 101l-10.5-2.2",
    fill: "url(#logo_svg__g2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M36.2 144.1s-4.8 12.6 10.9 12.6h41.3l-1.5-19.5-10.6-2.2",
    fill: "url(#logo_svg__g3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M177.4 69.1q-1.4 1.2-3.1 1.2c-1.4-.1-2.4-.6-3.2-1.7-1.6-1.7-1.3-4.3.4-6 9.1-8.5 15.7-17.8 20.6-29.4 1.4-3.2 2.6-6.5 3.8-9.9.6-2.4 3.1-3.6 5.4-2.9 1.2.4 2.1 1 2.6 2.2.5 1.1.7 2.1.3 3.3-5.6 17.4-13.3 30.7-26.8 43.2zm84.9 60c2 0 3.8-.8 5.3-2.2 1.4-1.6 2.1-3.2 2.1-5.4V84.6c0-2.3-.7-3.9-2.1-5.4-1.5-1.5-3.3-2.3-5.3-2.3h-51.5v.6c-3.5 20.6-14.4 43.3-29.5 57.8-.8.8-2 1.2-3.2 1.2-1.5-.1-2.4-.7-3.3-1.7-1.5-1.7-1.3-4.4.4-6 6.7-6.4 12.5-14.7 16.7-23.1 4.5-8.9 7.9-18.9 9.9-28.8h-14.6c-2.4 0-4.4-2-4.4-4.3v-.3c0-2.4 2-4.3 4.4-4.3h75.1c2.1 0 4.3.5 6.3 1.3 4 1.7 7 4.7 8.7 8.8.9 2 1.3 4.1 1.3 6.5v36.9c0 2.3-.4 4.4-1.3 6.4-1.7 4-4.7 7-8.7 8.9-2 .7-4.2 1.3-6.3 1.3h-9.5c-2.4 0-4.3-2-4.3-4.4v-.2c0-2.4 1.9-4.4 4.3-4.4zm21.5-66.4c1.2 2.1.6 4.7-1.3 5.9l-.2.2c-2.1 1.3-4.8.6-6-1.4l-25.7-40.8c-1.3-2-.8-4.8 1.2-6.1l.2-.1c2-1.3 4.8-.7 6.1 1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    className: "logo_svg__s3",
    d: "M379.4 138.3c-2.1 0-4.3-.5-6.3-1.4-4-1.6-7-4.6-8.7-8.6-.9-2.1-1.3-4.3-1.3-6.4V77.2H356c-2.5 0-4.4-2-4.4-4.4v-.1c0-2.4 1.9-4.3 4.4-4.3h7.1V23.3c0-2.5 1.8-4.4 4.3-4.4h.3c2.2 0 4.3 1.9 4.3 4.4v24.1c7-2.5 13.8-5.5 20.2-8.8 6.9-3.7 13.2-7.9 19.2-12.8 1.9-1.5 4.5-1.2 6.1.5l.1.2c.8 1 1.2 2.1 1.1 3.2-.1 1.2-.7 2.3-1.7 3.1-6.3 5-13.2 9.5-20.4 13.4-7.4 3.8-15.3 7.4-23.5 10.2-.4.1-.8.2-1.1.2v11.8h44.5c2.2 0 4.3 1.9 4.3 4.3v.1c0 2.4-2.1 4.4-4.3 4.4h-18.9l21.6 54c.9 2.1-.1 4.6-2.5 5.6v.1c-2.2.8-4.7-.3-5.6-2.5l-22.6-55.9c-.1-.4-.2-.8-.2-1.3H372v44.7c0 2.1.7 3.9 2.2 5.4 1.4 1.3 3.2 2.1 5.2 2.1h5.8c2.5 0 4.4 1.9 4.4 4.3v.3c0 2.4-1.9 4.3-4.4 4.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M546.6 129.2c2.4 0 4.4 1.9 4.4 4.4v.1c0 2.5-2 4.4-4.4 4.4H441.9c-2.5 0-4.4-1.9-4.4-4.4v-.1c0-2.5 1.9-4.4 4.4-4.4h48.7v-28.6h-43.5c-2.3 0-4.3-1.8-4.3-4.3s2-4.4 4.3-4.4h43.5V71.7h-43.7c-2.4 0-4.4-2-4.4-4.4V67c0-2.3 2-4.2 4.4-4.2h96.3c2.5 0 4.4 1.9 4.4 4.2v.3c0 2.4-1.9 4.4-4.4 4.4h-43.6v20.2h43.3c2.4 0 4.4 1.9 4.4 4.4 0 2.5-2 4.3-4.4 4.3h-43.3v28.6h30.3v-10c0-2.5 2-4.3 4.3-4.3h.3c2.5 0 4.4 1.8 4.4 4.3v10zM438.1 46.1c0-9 7.5-16.4 16.5-16.4h36V23c0-2.5 1.8-4.3 4.3-4.3h.3c2.2 0 4.3 1.8 4.3 4.3v6.7h35.9c8.9 0 16.3 7.4 16.3 16.4v3.2c0 2.5-1.8 4.3-4.2 4.3h-.3c-2.4 0-4.3-1.8-4.3-4.3v-3.2c0-4.4-3.7-7.5-7.5-7.5h-80.8c-4.4 0-7.5 3.7-7.5 7.5v3.2c0 2.5-2 4.3-4.4 4.3h-.2c-2.4 0-4.4-1.8-4.4-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M253.6 158.4h-12.9v8.3h11.4v1.4h-11.4v10.4H239V157h14.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M259.9 177.3h14.5v1.2h-16.2V157h15.5v1.4h-13.8v8.3h13v1.4h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M280.9 158.2v20.3h-1.7V157h2.5l12.8 20.6h.1V157h1.6v21.5h-2.6L281 158.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M302.2 177.3h15v1.2H300v-.8l14.6-19.3h-13.3V157h15.5v1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M336.3 156.9h1.7v21.6h-1.7v-10.4h-13.6v10.4h-1.6v-21.6h1.6v9.8h13.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    fillRule: "evenodd",
    className: "logo_svg__s3",
    d: "M359.7 178.5l-3-6.9h-10.8l-3 6.9h-1.7l9.2-21.6h1.7l9.4 21.6zm-13.3-8.3h9.6l-4.7-11.6h-.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M366.3 158.2v20.3h-1.6V157h2.5l12.7 20.6h.1V157h1.7v21.5H379l-12.6-20.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    className: "logo_svg__s3",
    d: "M397.2 167.4h9.2v7.8q-2.5 3.5-9.1 3.6-10.4-.5-10.8-10.9.4-10.8 10.3-11.2 7.3.1 9.6 6.2l-1.9.6q-1.5-5.3-7.9-5.4-7.9.5-8.3 9.9.4 9 8.7 9.6 5.5-.1 7.8-3v-5.8h-7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    fillRule: "evenodd",
    className: "logo_svg__s3",
    d: "M426.7 178.5h-9v-21.6h8.4q6.4.3 6.9 5.3-.1 4.1-4.7 5v.1q5.4.9 5.6 5.4-.1 5.7-7.2 5.8zm-1-20.2h-6.4v8.4h6.4q5.5-.2 5.6-4.4-.1-3.9-5.6-4zm.3 9.8h-6.7v9.1h7q6.1 0 6-4.8-.5-4.1-6.3-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    fillRule: "evenodd",
    className: "logo_svg__s3",
    d: "M455 178.5l-3-6.9h-10.8l-3 6.9h-1.8l9.3-21.6h1.7l9.4 21.6zm-13.3-8.3h9.6l-4.7-11.6h-.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Compound_Path>",
    fillRule: "evenodd",
    className: "logo_svg__s3",
    d: "M469.3 178.8q-9.9-.5-10.3-10.8.4-10.7 10.5-11.2 9.7.6 10.3 11.2-.4 10.4-10.5 10.8zm.1-20.6q-8.1.7-8.7 9.8.5 9 8.5 9.6 8.3-.4 8.8-9.6-.5-9.1-8.6-9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M83.9 13.5L88.6.8h-48l-4.7 12.7z",
    fill: "url(#logo_svg__g4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M34.5 17.3L1.4 108h48l33.1-90.7z",
    fill: "url(#logo_svg__g5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M118.8 49.6l4.6-12.6h-48l-4.6 12.6z",
    fill: "url(#logo_svg__g6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M69.4 53.4l-33.2 90.8h48l33.2-90.8z",
    fill: "url(#logo_svg__g7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M103.9 90.6L71 180.5h48l32.8-89.9z",
    fill: "url(#logo_svg__g8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    d: "M153.2 86.8l5-13.5h-48l-5 13.5z",
    fill: "url(#logo_svg__g9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    className: "logo_svg__s3",
    d: "M300 138.8c-1.8 0-3.4-1-4.2-2.7-1.1-2.3-.1-5 2.2-6.1 25.1-11.6 23.3-27.2 23.2-27.9-.1-.3-.1-.5-.1-.7V47.5c0-2.5 2.1-4.6 4.6-4.6 2.6 0 4.6 2.1 4.6 4.6v53.6c.4 3.4 1.3 23.6-28.4 37.3q-.9.4-1.9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    className: "logo_svg__s3",
    d: "M346.2 138.8c-1.9 0-3.7-1.1-4.4-3-3.2-8.7-12.7-13.6-12.8-13.6-2.3-1.2-3.2-4-2.1-6.2 1.2-2.3 3.9-3.2 6.2-2.1.5.3 12.9 6.6 17.4 18.7.9 2.4-.3 5.1-2.7 5.9q-.8.3-1.6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__<Path>",
    className: "logo_svg__s3",
    d: "M346 22.1c-2.7-2.4-5.6-3.6-9.3-3.6h-22.1q-5.3 0-9.1 3.6c-2.4 2.6-3.7 5.5-3.7 9.2v79.1c0 2.4 2 4.3 4.4 4.3h.2c2.4 0 4.4-1.9 4.4-4.3V31.3c0-2.2 1.6-3.8 3.8-3.8H336.7c2.3 0 4.1 1.6 4.1 3.8v79.1c0 2.4 2 4.3 4.4 4.3h.1c2.4 0 4.3-1.9 4.3-4.3V31.3c0-3.7-1.1-6.6-3.6-9.2z"
  }))));
}

export default SvgLogo;